import React from "react";
import * as Tools from "../../../../../helpers/Tools";
import SummaryItemGroup from "./SummaryItemGroup";

const CareGapYes = ({ inputData, careGapTitle, selectedCareGapOption, fileData }) => {

    const currentPath = location?.pathname;
    const basePath = currentPath?.substring(0, currentPath?.lastIndexOf('/') + 1); 

    const details = [
        {
            title: "Reason",
            info: `${selectedCareGapOption}`,
            pageUrl: `${basePath}`
        },
        inputData.sMethod && {
            title: "Screening Method",
            info: `${inputData.sMethod}`,
            pageUrl: `${basePath}updatehistory`
        } 
        ,

        {
            title: `${careGapTitle}`,
            info: `${inputData?.pMonth ? Tools.getFullMonthName(inputData?.pMonth) : ""} ${inputData?.pYear ? inputData?.pYear : ""}`,            
            pageUrl: `${basePath}updatehistory`
        },
        {
            title: "Facility",
            info: <>
                {inputData?.name && <div>{inputData?.name}</div>}
                {inputData?.pNumber && <div>P: {inputData?.pNumber}</div>}
                {inputData?.faxNumber && <div>F: {inputData?.faxNumber}</div>}
                {(inputData?.city || inputData?.state) && 
                    <div>
                        {inputData?.city && <span>{inputData?.city}</span>}
                        {inputData?.state && <span>{inputData?.city ? ", " : ""}{inputData?.state}</span>}
                    </div>
                }
            </>,            
            pageUrl: `${basePath}updatehistory`
        }];

    const attachments = fileData?.map((file) => ({
        fileName: file.FileName,
        fileSize: file.FileSize,
        variant: "file",       
        pageUrl: `${basePath}confirmhistory`
    }));

    const summaryItems = attachments && attachments.length > 0 ? details.concat(attachments) : details;

    return (
        <SummaryItemGroup
            summaryItems={summaryItems}
        />
    );
};

export default CareGapYes;